export default __webpack_public_path__ + "static/real-estate-a5756eebc5b860a102101412ae8681bb.png";